module.exports = __webpack_public_path__ + "bd4408808659ceeaafeff15c120ead59.png";